import React from "react";
import { Box, Typography } from "@mui/material";

import { convertADtoBS } from "../../../components/Calendar/functions/calendarFunctions";
import { ageFormatter } from "../../../helpers/formatters";
import ClientImageUploader from "../../../components/ImageUploader/ClientImageUploader";
import { IPD } from "../../../interfaces/IpdInterface";
import { Client } from "../../../interfaces/ClientInterface";
import { clientFullNameSelector } from "../../../reducers/client";
import { tl } from "../../../components/translate";

interface IpdProps {
  ipd: IPD & { bedCode: string };
  client: Partial<Client> & { customerNumber: string };
}

const Info = ({ label, value }: { label: string; value: string | number }) => (
  <Box display="flex" justifyContent="space-between" width="50%">
    <Typography fontWeight={600}>{label}</Typography>
    <Typography fontWeight={500}>{value}</Typography>
  </Box>
);

const IpdClientInfo = ({ ipd, client }: IpdProps): React.ReactNode | null => {
  if (!ipd) return null;
  const age = client?.dob ? ageFormatter(new Date(client.dob)) : "";

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 4, mb: 2 }}>
        <ClientImageUploader readOnly initialImage="" action={() => null} />
        <Box>
          <Typography variant="h6"> {clientFullNameSelector(client).toUpperCase()} </Typography>

          <Typography>
            {age} {client.gender ? tl(`clients.gender.${client.gender}`) : ""}
          </Typography>
        </Box>
      </Box>

      <Info label="Patient Id" value={client.customerNumber} />
      <Info label="Ipd Number" value={ipd.ipdNumber} />
      <Info label="Bed No." value={ipd.bedCode} />
      <Info
        label="Admission Date"
        value={convertADtoBS(new Date(ipd.dateOfAdmission)).formatted4}
      />
      <Info label="Phone No." value={client?.phone || ""} />
    </Box>
  );
};

export default IpdClientInfo;
